const noop = () => { /* noop */ };

export default noop;
